import {checkIfOwner} from "./checkIfOwner";

/**
 * Проверяет, принадлежит ли строение на указанной ячейке городу игрока
 *
 * @param {string} hexKey - Ключ ячейки строения в формате "q,r"
 * @param {Array} players
 * @param {Object} citiesCache - Кэш городов { [playerColor]: [city1, city2, ...] }
 * @returns {boolean} True если казарма принадлежит городу игрока, иначе false
 */
export const findOwner = (hexKey, players, citiesCache) => {
  return players.find((player) => {
    return checkIfOwner(hexKey, player.color, citiesCache);
  })
};